import Contact from "../../components/Contacts/Contacts";
import phoneIcon from '../../images/phoneIcon.svg';
import mailIcon from '../../images/mailIcon.svg';
import telegramIcon from '../../images/telegramIcon.svg';
import React, {useState} from "react";

const Contacts = () =>{
    const [isQuestion, setIsQuestion] = useState(false)
    return(
        <>
            <section className="flex flex-col pb-10">
                <h1 className='uppercase font-medium w-full
                        xl:text-4xl xl:pb-8 xl:pt-12
                        lg:text-4xl lg:pb-8 lg:pt-8
                        md:text-3xl md:pb-6 md:pt-6
                        sm:text-[28px] sm:py-4'>Свяжитесь с нами</h1>
                <p>Хотите задать вопрос или оформить заказ? Заполните форму ниже и мы свяжемся с вами в ближайшее время. </p>
                <div className="pt-16 grid grid-cols-[44%_44%] gap-[2%] items-center">
                    <div className="flex justify-between flex-col h-full">
                        <div className="flex flex-col gap-2 items-start">
                            <button onClick={()=>setIsQuestion(false)} className={` ${isQuestion === false ? 'text-[#304DB6] font-bold' : 'text-[#304DB6]'}`}>Сделать заказ</button>
                            <button onClick={()=>setIsQuestion(true)} className={` ${isQuestion === true ? 'text-[#304DB6] font-bold' : 'text-[#304DB6]'}`}>Задать вопрос</button>
                        </div>
                        
                        <div className="flex flex-col gap-5 pb-9">
                            <div className='flex gap-2'>
                                <img src={phoneIcon} alt='' className="w-4 h-4"/>
                                <a href="tel:+79555555555" className="text-xs text-[#304DB6]">+7 (955) 555-5555</a>
                            </div>
                            <div className='flex gap-2'>
                                <img src={mailIcon} alt='' className="w-4 h-4"/>
                                <a href="mailto:nejasiti@aero.com" className="text-xs text-[#304DB6]">nejasiti@aero.com</a>
                            </div>
                            <div className='flex gap-2'>
                                <img src={telegramIcon} alt='' className="w-4 h-4"/>
                                <a href="https://t.me/b33telgeuse" className="text-xs text-[#304DB6]">@b33telgeuse</a>
                            </div>
                        </div>
                    </div>
                    <Contact isQuestion = {isQuestion}/>
                </div>
                
            </section>
            
        </>
    )
}
export {Contacts};